// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file integrations_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { SyncUpdate } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file integrations_service.proto.
 */
export const file_integrations_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_sync_update, file_google_protobuf_timestamp]);

/**
 * @generated from message domain.EntraGetAuthorizeUriRequest
 */
export type EntraGetAuthorizeUriRequest = Message<"domain.EntraGetAuthorizeUriRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string redirect_uri = 2;
   */
  redirectUri: string;
};

/**
 * Describes the message domain.EntraGetAuthorizeUriRequest.
 * Use `create(EntraGetAuthorizeUriRequestSchema)` to create a new message.
 */
export const EntraGetAuthorizeUriRequestSchema: GenMessage<EntraGetAuthorizeUriRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 0);

/**
 * @generated from message domain.EntraGetAuthorizeUriResponse
 */
export type EntraGetAuthorizeUriResponse = Message<"domain.EntraGetAuthorizeUriResponse"> & {
  /**
   * @generated from field: string uri = 1;
   */
  uri: string;
};

/**
 * Describes the message domain.EntraGetAuthorizeUriResponse.
 * Use `create(EntraGetAuthorizeUriResponseSchema)` to create a new message.
 */
export const EntraGetAuthorizeUriResponseSchema: GenMessage<EntraGetAuthorizeUriResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 1);

/**
 * @generated from message domain.EntraFinishAuthorizationRequest
 */
export type EntraFinishAuthorizationRequest = Message<"domain.EntraFinishAuthorizationRequest"> & {
  /**
   * @generated from field: string result_query_string = 1;
   */
  resultQueryString: string;
};

/**
 * Describes the message domain.EntraFinishAuthorizationRequest.
 * Use `create(EntraFinishAuthorizationRequestSchema)` to create a new message.
 */
export const EntraFinishAuthorizationRequestSchema: GenMessage<EntraFinishAuthorizationRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 2);

/**
 * @generated from message domain.EntraFinishAuthorizationResponse
 */
export type EntraFinishAuthorizationResponse = Message<"domain.EntraFinishAuthorizationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message domain.EntraFinishAuthorizationResponse.
 * Use `create(EntraFinishAuthorizationResponseSchema)` to create a new message.
 */
export const EntraFinishAuthorizationResponseSchema: GenMessage<EntraFinishAuthorizationResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 3);

/**
 * @generated from message domain.EntraGetTenantRequest
 */
export type EntraGetTenantRequest = Message<"domain.EntraGetTenantRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: bool force_refresh = 2;
   */
  forceRefresh: boolean;
};

/**
 * Describes the message domain.EntraGetTenantRequest.
 * Use `create(EntraGetTenantRequestSchema)` to create a new message.
 */
export const EntraGetTenantRequestSchema: GenMessage<EntraGetTenantRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 4);

/**
 * @generated from message domain.EntraGetTenantResponse
 */
export type EntraGetTenantResponse = Message<"domain.EntraGetTenantResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp synchronized_at = 1;
   */
  synchronizedAt?: Timestamp | undefined;

  /**
   * @generated from field: repeated domain.EntraGetTenantResponse.User users = 2;
   */
  users: EntraGetTenantResponse_User[];

  /**
   * @generated from field: repeated domain.EntraGetTenantResponse.Group groups = 3;
   */
  groups: EntraGetTenantResponse_Group[];

  /**
   * @generated from field: bool is_unauthorized = 4;
   */
  isUnauthorized: boolean;
};

/**
 * Describes the message domain.EntraGetTenantResponse.
 * Use `create(EntraGetTenantResponseSchema)` to create a new message.
 */
export const EntraGetTenantResponseSchema: GenMessage<EntraGetTenantResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 5);

/**
 * @generated from message domain.EntraGetTenantResponse.User
 */
export type EntraGetTenantResponse_User = Message<"domain.EntraGetTenantResponse.User"> & {
  /**
   * @generated from field: string entra_user_id = 1;
   */
  entraUserId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: repeated string member_of = 3;
   */
  memberOf: string[];

  /**
   * @generated from field: bool matches_sync_filter = 4;
   */
  matchesSyncFilter: boolean;

  /**
   * @generated from field: bool account_enabled = 5;
   */
  accountEnabled: boolean;
};

/**
 * Describes the message domain.EntraGetTenantResponse.User.
 * Use `create(EntraGetTenantResponse_UserSchema)` to create a new message.
 */
export const EntraGetTenantResponse_UserSchema: GenMessage<EntraGetTenantResponse_User> = /*@__PURE__*/
  messageDesc(file_integrations_service, 5, 0);

/**
 * @generated from message domain.EntraGetTenantResponse.Group
 */
export type EntraGetTenantResponse_Group = Message<"domain.EntraGetTenantResponse.Group"> & {
  /**
   * @generated from field: string entra_group_id = 1;
   */
  entraGroupId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message domain.EntraGetTenantResponse.Group.
 * Use `create(EntraGetTenantResponse_GroupSchema)` to create a new message.
 */
export const EntraGetTenantResponse_GroupSchema: GenMessage<EntraGetTenantResponse_Group> = /*@__PURE__*/
  messageDesc(file_integrations_service, 5, 1);

/**
 * @generated from message domain.EntraClearAuthorizationRequest
 */
export type EntraClearAuthorizationRequest = Message<"domain.EntraClearAuthorizationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.EntraClearAuthorizationRequest.
 * Use `create(EntraClearAuthorizationRequestSchema)` to create a new message.
 */
export const EntraClearAuthorizationRequestSchema: GenMessage<EntraClearAuthorizationRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 6);

/**
 * @generated from message domain.EntraClearAuthorizationResponse
 */
export type EntraClearAuthorizationResponse = Message<"domain.EntraClearAuthorizationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.EntraClearAuthorizationResponse.
 * Use `create(EntraClearAuthorizationResponseSchema)` to create a new message.
 */
export const EntraClearAuthorizationResponseSchema: GenMessage<EntraClearAuthorizationResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 7);

/**
 * @generated from message domain.EntraGetSyncOperationsRequest
 */
export type EntraGetSyncOperationsRequest = Message<"domain.EntraGetSyncOperationsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.EntraGetSyncOperationsRequest.
 * Use `create(EntraGetSyncOperationsRequestSchema)` to create a new message.
 */
export const EntraGetSyncOperationsRequestSchema: GenMessage<EntraGetSyncOperationsRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 8);

/**
 * @generated from message domain.EntraSetSettingsRequest
 */
export type EntraSetSettingsRequest = Message<"domain.EntraSetSettingsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string entra_settings = 15;
   */
  entraSettings: string;
};

/**
 * Describes the message domain.EntraSetSettingsRequest.
 * Use `create(EntraSetSettingsRequestSchema)` to create a new message.
 */
export const EntraSetSettingsRequestSchema: GenMessage<EntraSetSettingsRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 9);

/**
 * @generated from message domain.EntraSetSettingsResponse
 */
export type EntraSetSettingsResponse = Message<"domain.EntraSetSettingsResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.EntraSetSettingsResponse.
 * Use `create(EntraSetSettingsResponseSchema)` to create a new message.
 */
export const EntraSetSettingsResponseSchema: GenMessage<EntraSetSettingsResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 10);

/**
 * @generated from message domain.EntraGetSyncOperationsResponse
 */
export type EntraGetSyncOperationsResponse = Message<"domain.EntraGetSyncOperationsResponse"> & {
  /**
   * @generated from field: repeated domain.EntraGetSyncOperationsResponse.CreateProfileOperation create_profiles = 1;
   */
  createProfiles: EntraGetSyncOperationsResponse_CreateProfileOperation[];
};

/**
 * Describes the message domain.EntraGetSyncOperationsResponse.
 * Use `create(EntraGetSyncOperationsResponseSchema)` to create a new message.
 */
export const EntraGetSyncOperationsResponseSchema: GenMessage<EntraGetSyncOperationsResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 11);

/**
 * @generated from message domain.EntraGetSyncOperationsResponse.CreateProfileOperation
 */
export type EntraGetSyncOperationsResponse_CreateProfileOperation = Message<"domain.EntraGetSyncOperationsResponse.CreateProfileOperation"> & {
  /**
   * @generated from field: string entra_user_id = 1;
   */
  entraUserId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string role_id = 3;
   */
  roleId: string;
};

/**
 * Describes the message domain.EntraGetSyncOperationsResponse.CreateProfileOperation.
 * Use `create(EntraGetSyncOperationsResponse_CreateProfileOperationSchema)` to create a new message.
 */
export const EntraGetSyncOperationsResponse_CreateProfileOperationSchema: GenMessage<EntraGetSyncOperationsResponse_CreateProfileOperation> = /*@__PURE__*/
  messageDesc(file_integrations_service, 11, 0);

/**
 * @generated from message domain.CsvSetIntegrationDataRequest
 */
export type CsvSetIntegrationDataRequest = Message<"domain.CsvSetIntegrationDataRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string data_json = 2;
   */
  dataJson: string;
};

/**
 * Describes the message domain.CsvSetIntegrationDataRequest.
 * Use `create(CsvSetIntegrationDataRequestSchema)` to create a new message.
 */
export const CsvSetIntegrationDataRequestSchema: GenMessage<CsvSetIntegrationDataRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 12);

/**
 * @generated from message domain.CsvSetIntegrationDataResponse
 */
export type CsvSetIntegrationDataResponse = Message<"domain.CsvSetIntegrationDataResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.CsvSetIntegrationDataResponse.
 * Use `create(CsvSetIntegrationDataResponseSchema)` to create a new message.
 */
export const CsvSetIntegrationDataResponseSchema: GenMessage<CsvSetIntegrationDataResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 13);

/**
 * @generated from message domain.CsvGetIntegrationDataRequest
 */
export type CsvGetIntegrationDataRequest = Message<"domain.CsvGetIntegrationDataRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.CsvGetIntegrationDataRequest.
 * Use `create(CsvGetIntegrationDataRequestSchema)` to create a new message.
 */
export const CsvGetIntegrationDataRequestSchema: GenMessage<CsvGetIntegrationDataRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 14);

/**
 * @generated from message domain.CsvGetIntegrationDataResponse
 */
export type CsvGetIntegrationDataResponse = Message<"domain.CsvGetIntegrationDataResponse"> & {
  /**
   * @generated from field: string data_json = 1;
   */
  dataJson: string;
};

/**
 * Describes the message domain.CsvGetIntegrationDataResponse.
 * Use `create(CsvGetIntegrationDataResponseSchema)` to create a new message.
 */
export const CsvGetIntegrationDataResponseSchema: GenMessage<CsvGetIntegrationDataResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 15);

/**
 * @generated from message domain.GWorkspaceGetAuthorizeUriRequest
 */
export type GWorkspaceGetAuthorizeUriRequest = Message<"domain.GWorkspaceGetAuthorizeUriRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string redirect_uri = 2;
   */
  redirectUri: string;
};

/**
 * Describes the message domain.GWorkspaceGetAuthorizeUriRequest.
 * Use `create(GWorkspaceGetAuthorizeUriRequestSchema)` to create a new message.
 */
export const GWorkspaceGetAuthorizeUriRequestSchema: GenMessage<GWorkspaceGetAuthorizeUriRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 16);

/**
 * @generated from message domain.GWorkspaceGetAuthorizeUriResponse
 */
export type GWorkspaceGetAuthorizeUriResponse = Message<"domain.GWorkspaceGetAuthorizeUriResponse"> & {
  /**
   * @generated from field: string uri = 1;
   */
  uri: string;
};

/**
 * Describes the message domain.GWorkspaceGetAuthorizeUriResponse.
 * Use `create(GWorkspaceGetAuthorizeUriResponseSchema)` to create a new message.
 */
export const GWorkspaceGetAuthorizeUriResponseSchema: GenMessage<GWorkspaceGetAuthorizeUriResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 17);

/**
 * @generated from message domain.GWorkspaceFinishAuthorizationRequest
 */
export type GWorkspaceFinishAuthorizationRequest = Message<"domain.GWorkspaceFinishAuthorizationRequest"> & {
  /**
   * @generated from field: string result_query_string = 1;
   */
  resultQueryString: string;
};

/**
 * Describes the message domain.GWorkspaceFinishAuthorizationRequest.
 * Use `create(GWorkspaceFinishAuthorizationRequestSchema)` to create a new message.
 */
export const GWorkspaceFinishAuthorizationRequestSchema: GenMessage<GWorkspaceFinishAuthorizationRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 18);

/**
 * @generated from message domain.GWorkspaceFinishAuthorizationResponse
 */
export type GWorkspaceFinishAuthorizationResponse = Message<"domain.GWorkspaceFinishAuthorizationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message domain.GWorkspaceFinishAuthorizationResponse.
 * Use `create(GWorkspaceFinishAuthorizationResponseSchema)` to create a new message.
 */
export const GWorkspaceFinishAuthorizationResponseSchema: GenMessage<GWorkspaceFinishAuthorizationResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 19);

/**
 * @generated from message domain.GWorkspaceClearAuthorizationRequest
 */
export type GWorkspaceClearAuthorizationRequest = Message<"domain.GWorkspaceClearAuthorizationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.GWorkspaceClearAuthorizationRequest.
 * Use `create(GWorkspaceClearAuthorizationRequestSchema)` to create a new message.
 */
export const GWorkspaceClearAuthorizationRequestSchema: GenMessage<GWorkspaceClearAuthorizationRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 20);

/**
 * @generated from message domain.GWorkspaceClearAuthorizationResponse
 */
export type GWorkspaceClearAuthorizationResponse = Message<"domain.GWorkspaceClearAuthorizationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.GWorkspaceClearAuthorizationResponse.
 * Use `create(GWorkspaceClearAuthorizationResponseSchema)` to create a new message.
 */
export const GWorkspaceClearAuthorizationResponseSchema: GenMessage<GWorkspaceClearAuthorizationResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 21);

/**
 * @generated from message domain.GWorkspaceListRequest
 */
export type GWorkspaceListRequest = Message<"domain.GWorkspaceListRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: bool force_refresh = 2;
   */
  forceRefresh: boolean;
};

/**
 * Describes the message domain.GWorkspaceListRequest.
 * Use `create(GWorkspaceListRequestSchema)` to create a new message.
 */
export const GWorkspaceListRequestSchema: GenMessage<GWorkspaceListRequest> = /*@__PURE__*/
  messageDesc(file_integrations_service, 22);

/**
 * @generated from message domain.GWorkspaceListResponse
 */
export type GWorkspaceListResponse = Message<"domain.GWorkspaceListResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: repeated domain.GWorkspaceListResponse.User users = 2;
   */
  users: GWorkspaceListResponse_User[];
};

/**
 * Describes the message domain.GWorkspaceListResponse.
 * Use `create(GWorkspaceListResponseSchema)` to create a new message.
 */
export const GWorkspaceListResponseSchema: GenMessage<GWorkspaceListResponse> = /*@__PURE__*/
  messageDesc(file_integrations_service, 23);

/**
 * @generated from message domain.GWorkspaceListResponse.User
 */
export type GWorkspaceListResponse_User = Message<"domain.GWorkspaceListResponse.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message domain.GWorkspaceListResponse.User.
 * Use `create(GWorkspaceListResponse_UserSchema)` to create a new message.
 */
export const GWorkspaceListResponse_UserSchema: GenMessage<GWorkspaceListResponse_User> = /*@__PURE__*/
  messageDesc(file_integrations_service, 23, 0);

/**
 * @generated from service domain.IntegrationsService
 */
export const IntegrationsService: GenService<{
  /**
   * no errors
   *
   * @generated from rpc domain.IntegrationsService.EntraGetAuthorizeUri
   */
  entraGetAuthorizeUri: {
    methodKind: "unary";
    input: typeof EntraGetAuthorizeUriRequestSchema;
    output: typeof EntraGetAuthorizeUriResponseSchema;
  },
  /**
   * errors:
   * - BadRequest (10400): result_query_string failed to parse
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100)
   * - IntegrationUnauthorized (80401): if authorization failed for unknown reasons
   * - IntegrationNotInitialized (80400): the user canceled the authorization flow
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.EntraFinishAuthorization
   */
  entraFinishAuthorization: {
    methodKind: "unary";
    input: typeof EntraFinishAuthorizationRequestSchema;
    output: typeof EntraFinishAuthorizationResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100)
   * - IntegrationNotInitialized (80400)
   * - IntegrationUnauthorized (80401): if unauthorized, only thrown if force_refresh is set
   * - IntegrationDataNotAvailable (80404): data is not available, probably because it is still syncing
   * - IntegrationInternal (80500)
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.EntraGetTenant
   */
  entraGetTenant: {
    methodKind: "unary";
    input: typeof EntraGetTenantRequestSchema;
    output: typeof EntraGetTenantResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100)
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.EntraClearAuthorization
   */
  entraClearAuthorization: {
    methodKind: "unary";
    input: typeof EntraClearAuthorizationRequestSchema;
    output: typeof EntraClearAuthorizationResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100)
   * - IntegrationNotInitialized (80400)
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.EntraGetSyncOperations
   */
  entraGetSyncOperations: {
    methodKind: "unary";
    input: typeof EntraGetSyncOperationsRequestSchema;
    output: typeof EntraGetSyncOperationsResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationInsufficientAccess (60100)
   * - OrganizationNotFound (60400)
   * - MalformedEntraSettings (60472)
   * - RoleNotFound (61404): role for provisioning not found
   * - InvalidRole (61405): entra settings have invalid role
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.EntraSetSettings
   */
  entraSetSettings: {
    methodKind: "unary";
    input: typeof EntraSetSettingsRequestSchema;
    output: typeof EntraSetSettingsResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationInsufficientAccess (60100)
   * - OrganizationNotFound (60400)
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.CsvSetIntegrationData
   */
  csvSetIntegrationData: {
    methodKind: "unary";
    input: typeof CsvSetIntegrationDataRequestSchema;
    output: typeof CsvSetIntegrationDataResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationInsufficientAccess (60100)
   * - OrganizationNotFound (60400)
   * - IntegrationNotInitialized (80400)
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.CsvGetIntegrationData
   */
  csvGetIntegrationData: {
    methodKind: "unary";
    input: typeof CsvGetIntegrationDataRequestSchema;
    output: typeof CsvGetIntegrationDataResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationInsufficientAccess (60100)
   * - IntegrationUnauthorized (80401): if authorization initialization failed for unknown reasons
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.GWorkspaceGetAuthorizeUri
   */
  gWorkspaceGetAuthorizeUri: {
    methodKind: "unary";
    input: typeof GWorkspaceGetAuthorizeUriRequestSchema;
    output: typeof GWorkspaceGetAuthorizeUriResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100)
   * - IntegrationUnauthorized (80401): if authorization failed for unknown reasons
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.GWorkspaceFinishAuthorization
   */
  gWorkspaceFinishAuthorization: {
    methodKind: "unary";
    input: typeof GWorkspaceFinishAuthorizationRequestSchema;
    output: typeof GWorkspaceFinishAuthorizationResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100)
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.GWorkspaceClearAuthorization
   */
  gWorkspaceClearAuthorization: {
    methodKind: "unary";
    input: typeof GWorkspaceClearAuthorizationRequestSchema;
    output: typeof GWorkspaceClearAuthorizationResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100)
   * - IntegrationNotInitialized (80400)
   * - IntegrationUnauthorized (80401)
   * - IntegrationInternal (80500)
   * - Internal (10500)
   *
   * @generated from rpc domain.IntegrationsService.GWorkspaceList
   */
  gWorkspaceList: {
    methodKind: "unary";
    input: typeof GWorkspaceListRequestSchema;
    output: typeof GWorkspaceListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_integrations_service, 0);

